var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"dataList[0].dataList","label":"日期","width":"180"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }